import React from "react";
import { useNavigate } from "react-router-dom";
import { signInWithGoogle } from "../firebase";

export default function LoginPage() {
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      await signInWithGoogle();
      navigate("/dashboard");
    } catch (err) {
      alert("Login error: " + err.message);
    }
  };

  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      <h2>ورود با گوگل</h2>
      <button onClick={handleLogin}>ورود</button>
    </div>
  );
}
